<template>
  <div style="width: 100%; height: 100%">
    <div v-if="!markers.length" class="loadingContainer">
      <loading></loading>
    </div>
    <div id="map"></div>
  </div>
  <!-- <div >
    <GmapMap
      :center="initialLocation"
      :zoom="5"
      style="width: 100%; height: 400px"
    >
      <GmapCluster :grid-size="100" :maxZoom="12">
        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="{lat: Number(m.lat), lng: Number(m.lng)}"
          :clickable="true"
          @click="$emit('markerClick',m)"
        >
        </GmapMarker>
      </GmapCluster>
    </GmapMap>
  </div>-->
  <!-- <div style="height:400px; width:100%;">
    <v-map :zoom=5 :center="initialLocation">
      <v-tilelayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></v-tilelayer>
      <v-marker-cluster :options="clusterOptions" @clusterclick="click()" @ready="ready" ref="clusterRef">
        <v-marker v-for="l in markers" :key="l.userId" :lat-lng="[l.lat, l.lng]" @click="$emit('markerClick',l)">
          <v-popup :content="l.alias"></v-popup>
          <v-icon>
            <img :src="icon" width="30" height="30" />
          </v-icon>
        </v-marker>
      </v-marker-cluster>
    </v-map>
  </div>-->
</template>

<script>
// import * as Vue2Leaflet from "vue2-leaflet";
// import { latLng, Icon, icon } from "leaflet";
// import Vue2LeafletMarkercluster from "vue2-leaflet-markercluster";
// import iconUrl from "../assets/marker-icon2.png";
import Supercluster from "supercluster";
import Loading from "../components/Loading";

export default {
  name: "MapView",
  components: {
    Loading
    // "v-map": Vue2Leaflet.LMap,
    // "v-tilelayer": Vue2Leaflet.LTileLayer,
    // // 'v-icondefault': Vue2Leaflet.LIconDefault,
    // "v-marker": Vue2Leaflet.LMarker,
    // "v-popup": Vue2Leaflet.LPopup,
    // "v-icon": Vue2Leaflet.LIcon,
    // "v-marker-cluster": Vue2LeafletMarkercluster
  },
  data() {
    return {
      locations: [],
      mapToUse: undefined,
      markerPoints: undefined,
      markers12: undefined,
      superClusterIndex: undefined
    };
  },
  props: {
    markers: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.mapToUse = L.map("map").setView(new L.LatLng(56.166939, 10.190946), 5);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapToUse);

    this.markers12 = L.geoJson(null, {
      pointToLayer: this.createClusterIcon
    }).addTo(this.mapToUse);

    this.mapToUse.on("moveend", this.update);

    this.markers12.on("click", e => this.markerOnlick(e));
  },
  methods: {
    createClusterIcon(feature, latlng) {
      // if (!feature.properties.cluster) return L.marker(latlng);
      if (!feature.properties.cluster){
        let pinColorClass = "greyPin";
        switch (feature.properties.status) {
          case "1":
            pinColorClass = "greenPin";
            break;
          case "2":
            pinColorClass = "yellowPin";
            break;
          case "4":
            pinColorClass = "redPin";
            break;
          default:
            pinColorClass = "greyPin";
            break;
        }
        const icon = L.divIcon({
          html: `<div class="pin1"></div>`,
          className: `${pinColorClass}`,
          iconSize: L.point(40, 40)
        });

        return L.marker(latlng, { icon });
      }
      const count = feature.properties.point_count;
      const size = count < 100 ? "small" : count < 1000 ? "medium" : "large";
      const icon = L.divIcon({
        html: `<div><span>${feature.properties.point_count}</span></div>`,
        className: `marker-cluster marker-cluster-${size}`,
        iconSize: L.point(40, 40)
      });

      return L.marker(latlng, { icon });
    },
    parseCoordinates(geojson) {
      let points = [];
      for (let i = 0; i < geojson.length; i++) {
        points.push({
          type: "Feature",
          properties: {
            alias: geojson[i].alias,
            lat: geojson[i].lat,
            lng: geojson[i].lng,
            status: geojson[i].status,
            userid: geojson[i].userid
          },
          geometry: {
            type: "Point",
            coordinates: [geojson[i].lng, geojson[i].lat]
          }
        });
      }
      return points;
    },
    update() {
      // if (!ready) return;
      var bounds = this.mapToUse.getBounds();
      var bbox = [
        bounds.getWest(),
        bounds.getSouth(),
        bounds.getEast(),
        bounds.getNorth()
      ];
      var zoom = this.mapToUse.getZoom();
      this.superClusterIndex = new Supercluster({
        log: false,
        radius: 60,
        extent: 256,
        maxZoom: 17
      });
      if(this.markerPoints && this.markerPoints.length){
        this.superClusterIndex.load(this.markerPoints);
        // let clusters = index.getClusters([-180, -85, 180, 85], 2);

        var clusters = this.superClusterIndex.getClusters(bbox, zoom);
        this.markers12.clearLayers();
        this.markers12.addData(clusters);
      }
    },
    markerOnlick(e) {
      var clusterId = e.layer.feature.properties.cluster_id;
      var center = e.latlng;
      var expansionZoom;
      if (clusterId) {
        expansionZoom = this.superClusterIndex.getClusterExpansionZoom(
          clusterId
        );
        this.mapToUse.flyTo(center, expansionZoom);
      } else {
        this.$emit("markerClick", e.layer.feature.properties);
      }
    }
  },
  watch: {
    markers: async function(newVal) {
      this.markerPoints = await this.parseCoordinates(newVal);
      this.update();
    }
  }
};
</script>
<style>
.marker-cluster-small {
  background-color: rgba(181, 226, 140, 0.6);
}
.marker-cluster-small div {
  background-color: rgba(110, 204, 57, 0.6);
}

.marker-cluster-medium {
  background-color: rgba(241, 211, 87, 0.6);
}
.marker-cluster-medium div {
  background-color: rgba(240, 194, 12, 0.6);
}

.marker-cluster-large {
  background-color: rgba(253, 156, 115, 0.6);
}
.marker-cluster-large div {
  background-color: rgba(241, 128, 23, 0.6);
}

.marker-cluster {
  background-clip: padding-box;
  border-radius: 20px;
}
.marker-cluster div {
  width: 30px;
  height: 30px;
  margin-left: 5px;
  margin-top: 5px;
  text-align: center;
  border-radius: 15px;
  font: 10px "Helvetica Neue", Arial, Helvetica, sans-serif;
}
.marker-cluster span {
  line-height: 30px;
}
.marker-pin div {
  background-color: rgba(110, 204, 57, 0.6);
}
.pin1 {
  border-radius: 50% 50% 50% 0;
  border: 2px solid #fff;
  width: 20px;
  height: 20px;
  transform: rotate(-45deg);
  margin: -5px 8px;
}
.greyPin div{
  background-color: #808080;
}
.greenPin div{
  background-color: #00ff00;
}
.yellowPin div{
  background-color: #FFFF00;
}
.redPin div{
  background-color: #ff0000;
}
.loadingContainer {
  width: 100%;
  background-color: rgba(0,0,0,0.3);
  position: absolute;
  z-index: 5550;
  left: 0;
  right: 0;
  top: 80px;
  height: 78vh;
}
</style>
